

export class SellerListRequest {


    public limit: number;
    public offset: number;
    public name: string;
    public email: string;
    public status: number;
    public count: number;
    public customerId: number;
    public keyword: string;

    constructor(sellerListRequest: any) {
        this.limit = sellerListRequest.limit || '';
        this.offset = sellerListRequest.offset || '';
        this.name = sellerListRequest.name || '';
        this.email = sellerListRequest.email || '';
        this.status = sellerListRequest.status;
        this.count = sellerListRequest.count || '';
        this.customerId = sellerListRequest.customerId || '';
        this.keyword = sellerListRequest.keyword || '';

    }
}
